import React from "react";
import { Button } from "@mantine/core";
import type { ButtonProps } from "@mantine/core";

export type ActionType = "save" | "close" | "delete";

// Use intersection type to properly combine ButtonProps with HTML button props
export type CustomActionButtonProps = ButtonProps &
  React.ComponentPropsWithoutRef<"button"> & {
    action: ActionType;
  };

const getActionConfig = (action: ActionType) => {
  switch (action) {
    case "save":
      return { icon: <></> };
    case "close":
      return { icon: <></>, variant: "carrot" as const };
    case "delete":
      return { icon: <></>, variant: "carrot" as const };
  }
};

export const CustomActionButton = React.forwardRef<
  HTMLButtonElement,
  CustomActionButtonProps
>(({ action, children, leftSection, rightSection, variant, ...props }, ref) => {
  const config = getActionConfig(action);
  const finalVariant = variant ?? config.variant;

  let iconSection: {
    leftSection?: React.ReactNode;
    rightSection?: React.ReactNode;
  } = {};
  if (!leftSection && !rightSection) {
    iconSection =
      action === "close"
        ? { leftSection: <></> }
        : { rightSection: <></> };
  }

  return (
    <Button
      ref={ref}
      variant={finalVariant as any}
      leftSection={leftSection}
      rightSection={rightSection}
      {...iconSection}
      {...props} // includes onClick, onMouseEnter, etc.
    >
      {children}
    </Button>
  );
});

CustomActionButton.displayName = "CustomActionButton";
